import React, { useState } from 'react';
import { Mail, Phone, Send } from 'lucide-react';
import { toast } from 'sonner';

const Contact = ({ translations }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock submission - will be connected to backend later
    console.log('Form submitted:', formData);
    toast.success(translations.contact.success);
    setFormData({
      name: '',
      email: '',
      phone: '',
      service: '',
      message: ''
    });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{translations.contact.title}</h2>
          <p className="section-subtitle">{translations.contact.subtitle}</p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-card">
              <div className="contact-card-header">
                <h3 className="contact-card-title">ATOM LOGOS</h3>
                <p className="contact-card-subtitle">Oksana TOMA</p>
              </div>
              
              <div className="contact-details">
                <div className="contact-item">
                  <Mail size={20} />
                  <div>
                    <p className="contact-label">Email</p>
                    <a href="mailto:contact@atom-logos.fr" className="contact-value">
                      contact@atom-logos.fr
                    </a>
                  </div>
                </div>
                
                <div className="contact-item">
                  <Phone size={20} />
                  <div>
                    <p className="contact-label">{translations.contact.phone || 'Téléphone'}</p>
                    <a href="tel:+33652648235" className="contact-value">
                      +33 (0)6 52 64 82 35
                    </a>
                  </div>
                </div>
              </div>

              <div className="pricing-note">
                <p>{translations.contact.pricing}</p>
              </div>
            </div>
          </div>

          <div className="contact-form-wrapper">
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label className="form-label">{translations.contact.name}</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="form-input"
                  required
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">{translations.contact.email}</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-input"
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">{translations.contact.phone}</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="form-input"
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">{translations.contact.service}</label>
                <select
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  className="form-select"
                  required
                >
                  <option value="">{translations.contact.selectService}</option>
                  <option value="translation">{translations.contact.translation}</option>
                  <option value="interpretationSworn">{translations.contact.interpretationSworn}</option>
                  <option value="interpreterB2B">{translations.contact.interpreterB2B}</option>
                </select>
              </div>

              <div className="form-group">
                <label className="form-label">{translations.contact.message}</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  className="form-textarea"
                  rows="5"
                  required
                ></textarea>
              </div>

              <button type="submit" className="btn-primary btn-submit">
                <Send size={20} style={{ marginRight: '8px' }} />
                {translations.contact.send}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
